import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='apiVersion' subtitle='"legacy" | "2.4"' label='Default: "2.4"' mdxType="Item">
      <p>{`  Specifies the API version to use when interacting with the Primer backend.`}</p>
      <ul>
        <li parentName="ul">{`If not explicitly set, defaults to version `}<inlineCode parentName="li">{`'2.4'`}</inlineCode>{`.`}</li>
        <li parentName="ul">{`Set this to `}<inlineCode parentName="li">{`'legacy'`}</inlineCode>{` if you encounter compatibility issues with the latest API version and wish to revert to the previous stable behavior.`}</li>
      </ul>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      